import { useMemo } from "react"
import { LineRecord, NodeState, SetOperation } from "../../services/modal"
import { Select } from "antd"

export interface UnitStates {
  nodes: NodeState[],
  lines: LineRecord[],
  operations: SetOperation[],
}

export interface UnitSelectProps {
  units: UnitStates
  value: string | undefined
  onChange?: (value: string) => void
  style?: any
  showName?: boolean
}

export const UnitSelect = (props: UnitSelectProps) => {
  const {units, value, onChange, style, showName = false} = props

  const unitSelectOptions = useMemo(() => {
    const {nodes, lines, operations} = units
    return [
      {
        label: <span>Equipment</span>,
        options: nodes.map(node => {
          const label = showName ? `${node.equipment.name}:[${node.tag}]` : node.tag
          return {label, value: node.id}
        }),
      },
      {
        label: <span>Stream</span>,
        options: lines.map(line => {
          const label = showName ? `Stream:[${line.tag || line.id.substring(0,4)}]` : line.tag
          return {label, value: line.id}
        }),
      },
      {
        label: <span>Set</span>,
        options: operations.map(operation => {
          const label = showName ? `Set:[${operation.tag || operation.id.substring(0,4)}]` : operation.tag
          return {label, value: operation.id}
        }),
      },
    ]
  }, [units])

  return <Select showSearch optionFilterProp='label' options={unitSelectOptions} value={value} onChange={onChange} style={style} />
}